import { render, staticRenderFns } from "./Canuseamount.vue?vue&type=template&id=5d28d9f7&"
import script from "./Canuseamount.vue?vue&type=script&lang=js&"
export * from "./Canuseamount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports